(function () {
  'use strict';

  var data = window.__deliveryData;
  if (!data) return;

  var TERRITORIES = ['Northwest Territories', 'Nunavut', 'Yukon'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function parseISO(str) {
    if (!str) return null;
    var parts = str.split('-');
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  }

  /* "Thu, Mar 5" */
  function fmtDate(d) {
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  /* "Mar 5" */
  function fmtShort(d) {
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function isTomorrow(d) {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return d.getFullYear() === tomorrow.getFullYear() && d.getMonth() === tomorrow.getMonth() && d.getDate() === tomorrow.getDate();
  }

  function getProvinceInfo(province) {
    if (!province) return null;
    var key = province;
    if (TERRITORIES.indexOf(province) !== -1) key = 'Domestic';
    return data.dates[key] || null;
  }

  /* ── Date range ─────────────────────────────── */

  function buildRange(info) {
    if (!info) return null;
    var minD = parseISO(info.min);
    var maxD = parseISO(info.max);
    if (!minD || !maxD) return null;

    var sameDay = info.min === info.max;
    var sameMonth = minD.getMonth() === maxD.getMonth();
    var minIsTomorrow = isTomorrow(minD);

    if (sameDay && minIsTomorrow) return 'Tomorrow, ' + fmtShort(minD);
    if (sameDay) return fmtDate(minD);

    var minPart = minIsTomorrow ? 'Tomorrow, ' + fmtShort(minD) : fmtDate(minD);

    var maxPart;
    if (sameMonth) {
      maxPart = minIsTomorrow
        ? String(maxD.getDate())
        : DAYS[maxD.getDay()] + ', ' + maxD.getDate();
    } else {
      maxPart = fmtDate(maxD);
    }

    return minPart + ' \u2013 ' + maxPart;
  }

  /* ── Text generators ────────────────────────── */

  function getDeliveryText(province, includeProvince) {
    var range = buildRange(getProvinceInfo(province));
    if (!range) return null;
    var prefix = 'Delivery';
    if (includeProvince && province) prefix = 'Delivery to ' + province;
    return prefix + ' ' + range;
  }

  function getDatesText(province) {
    return buildRange(getProvinceInfo(province));
  }

  /* ── DOM update ─────────────────────────────── */

  function updateAll() {
    var province = localStorage.getItem('shipping_province') || 'Ontario';
    var els = document.querySelectorAll('[data-delivery-date]');

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var type = el.getAttribute('data-delivery-date');
      var text = null;

      if (type === 'delivery') {
        var withProvince = el.hasAttribute('data-delivery-province');
        text = getDeliveryText(province, withProvince);
      } else if (type === 'delivery-label') {
        var info = getProvinceInfo(province);
        if (info && buildRange(info)) {
          text = el.hasAttribute('data-delivery-province')
            ? 'Delivery to ' + province
            : 'Delivery';
        }
      } else if (type === 'dates') {
        text = getDatesText(province);
      }

      el.textContent = text || '';
      el.style.display = text ? '' : 'none';

      /* Toggle delivery-wrapper (cart drawer sub-line) */
      var wrapper = el.closest('[data-delivery-wrapper]');
      if (wrapper) {
        wrapper.style.display = text ? '' : 'none';
      }

      /* Toggle fallback within courier-notice */
      var notice = el.closest('.courier-notice');
      if (notice) {
        var fallback = notice.querySelector('.courier-notice__fallback');
        if (fallback) {
          var hasVisible = false;
          var noticeEls = notice.querySelectorAll('[data-delivery-date]');
          for (var n = 0; n < noticeEls.length; n++) {
            if (noticeEls[n].style.display !== 'none' && noticeEls[n].textContent) {
              hasVisible = true;
              break;
            }
          }
          fallback.style.display = hasVisible ? 'none' : '';
        }
      }
    }
  }

  /* ── Init ────────────────────────────────────── */

  function init() {
    updateAll();
    document.addEventListener('province-selected', updateAll);
    window.addEventListener('storage', function (e) {
      if (e.key === 'shipping_province') updateAll();
    });
    document.addEventListener('cart:updated', function () {
      requestAnimationFrame(updateAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
